import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CompanyContextService } from '../services/company-context.service';

/**
 * AA-31: agrega la empresa activa como header X-Company-Id (antes: companyId como query param)
 * -- TenantGuard en el backend valida este header contra las membresías reales del usuario antes
 * de dejar pasar la request a cualquier controller; los controllers ya no aceptan companyId como
 * query param en absoluto. Se excluyen /api/auth (no requiere empresa) y /api/companies (evita
 * recursión, ya que CompanyContextService llama a este mismo endpoint para resolver companyId).
 *
 * AA-27: la petición espera siempre a que companyId esté resuelto (switchMap sobre
 * getCompanyId()) antes de salir -- nunca debe salir una llamada a /api/* sin companyId
 * cuando el endpoint lo requiere. Si companyId no se pudo resolver (empresa inexistente o
 * falla al consultarla), la petición falla explícitamente en vez de salir sin el parámetro.
 */
export const companyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/') || req.url.includes('/api/auth') || req.url.includes('/api/companies')) {
    return next(req);
  }
  const companyContext = inject(CompanyContextService);
  return companyContext.getCompanyId().pipe(
    switchMap(companyId => {
      if (!companyId) {
        return throwError(() => new Error('No se pudo resolver la empresa activa antes de llamar a la API.'));
      }
      return next(req.clone({ setHeaders: { 'X-Company-Id': companyId } }));
    })
  );
};
